/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const NDCORClaimRadioData = [
  { name: 'NDC', value: 'ndc' },
  { name: 'Claim ID', value: 'claimId' },
];

export const RegularSuppData = [
  { name: 'Regular', value: 'Regular' },
  { name: 'Supplemental', value: 'Supplemental' },
];

export const SelectedClaimModeData = [
  { name: 'Maintain', value: 'maintain' },
  { name: 'Display', value: 'display' },
];

export const SelectedClaimTab = [
  { label: 'Drug', value: 'drug' },
  { label: 'Claims', value: 'claims' },
];
export const getDisputeResolutionToggleFromClaimRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return false;
  }
  return rows.some((row) => Number(row.disputeResolutionInd) === 1);
};

/** Matches System > User Default "Default Units Modified for Dispute Resolution". */
export const getDisputeResolutionToggleFromUserDefault = (userDefaults) =>
  Number(userDefaults?.defDisputeResolutionInd) === 1;

export const resolveDisputeResolutionToggle = ({
  isPageLoad,
  userDefaults,
  tableRows,
}) =>
  isPageLoad
    ? getDisputeResolutionToggleFromUserDefault(userDefaults)
    : getDisputeResolutionToggleFromClaimRows(tableRows);

